/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import {
  Button,
  Divider,
  Flex,
  Heading,
  Text,
  View,
} from "@aws-amplify/ui-react";
export default function DocumentViewPlayerCard(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="0"
      direction="row"
      width="900px"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "DocumentViewPlayerCard")}
      {...rest}
    >
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "Card Area")}
      >
        <Heading
          width="unset"
          height="unset"
          shrink="0"
          alignSelf="stretch"
          level="1"
          children="Document"
          {...getOverrideProps(overrides, "dvcHeader")}
        ></Heading>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "Divider")}
        ></Divider>
        <Flex
          gap="9px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "dvcActionsView")}
        >
          <Button
            width="unset"
            height="unset"
            shrink="0"
            size="small"
            isDisabled={false}
            variation="primary"
            children="Back to Documents"
            {...getOverrideProps(overrides, "dvcBackButton40235204")}
          ></Button>
          <Button
            width="unset"
            height="unset"
            shrink="0"
            size="small"
            isDisabled={false}
            variation="primary"
            children="Edit Document"
            {...getOverrideProps(overrides, "dvcBackButton40236773")}
          ></Button>
        </Flex>
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-end"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "dvcAttachmentView40235083")}
        >
          <Flex
            gap="10px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "dvcAttachmentContainer")}
          >
            <View
              width="560px"
              height="560px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "dvcAttachmentView40235085")}
            ></View>
            <Divider
              height="unset"
              shrink="0"
              alignSelf="stretch"
              size="small"
              orientation="vertical"
              {...getOverrideProps(overrides, "dvcDivider")}
            ></Divider>
            <Flex
              gap="6px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              grow="1"
              shrink="1"
              basis="0"
              alignSelf="stretch"
              position="relative"
              padding="9px 9px 9px 9px"
              {...getOverrideProps(overrides, "dcViewRow40235087")}
            >
              <Flex
                gap="6px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                border="1px SOLID rgba(0,0,0,1)"
                padding="8px 8px 8px 8px"
                {...getOverrideProps(overrides, "dcViewRow40235088")}
              >
                <Button
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  padding="0px 0px 0px 0px"
                  shrink="0"
                  size="small"
                  isDisabled={false}
                  variation="link"
                  children="MRI_Brain_Scan_Top_View"
                  {...getOverrideProps(overrides, "dvcAttachmentTitle40235089")}
                ></Button>
                <Text
                  fontFamily="Inter"
                  fontSize="12px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="12px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Type: Video"
                  {...getOverrideProps(overrides, "dvcAttachmentType40235090")}
                ></Text>
              </Flex>
              <Flex
                gap="6px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="9px 9px 9px 9px"
                {...getOverrideProps(overrides, "dcViewRow40235091")}
              >
                <Button
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  padding="0px 0px 0px 0px"
                  shrink="0"
                  size="small"
                  isDisabled={false}
                  variation="link"
                  children="MRI_Brain_Scan_Left_View"
                  {...getOverrideProps(overrides, "dvcAttachmentTitle40235092")}
                ></Button>
                <Text
                  fontFamily="Inter"
                  fontSize="12px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="12px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Type: Video"
                  {...getOverrideProps(overrides, "dvcAttachmentType40235093")}
                ></Text>
              </Flex>
              <Flex
                gap="6px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="9px 9px 9px 9px"
                {...getOverrideProps(overrides, "dcViewRow40235094")}
              >
                <Button
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  padding="0px 0px 0px 0px"
                  shrink="0"
                  size="small"
                  isDisabled={false}
                  variation="link"
                  children="MIR_Image1"
                  {...getOverrideProps(overrides, "dvcAttachmentTitle40235095")}
                ></Button>
                <Text
                  fontFamily="Inter"
                  fontSize="12px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="12px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Type: Image"
                  {...getOverrideProps(overrides, "dvcAttachmentType40235096")}
                ></Text>
              </Flex>
              <Flex
                gap="6px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="9px 9px 9px 9px"
                {...getOverrideProps(overrides, "dcViewRow40235097")}
              >
                <Button
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  padding="0px 0px 0px 0px"
                  shrink="0"
                  size="small"
                  isDisabled={false}
                  variation="link"
                  children="MIR_Image2"
                  {...getOverrideProps(overrides, "dvcAttachmentTitle40235098")}
                ></Button>
                <Text
                  fontFamily="Inter"
                  fontSize="12px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="12px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Type: Image"
                  {...getOverrideProps(overrides, "dvcAttachmentType40235099")}
                ></Text>
              </Flex>
              <Flex
                gap="6px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="9px 9px 9px 9px"
                {...getOverrideProps(overrides, "dcViewRow40235100")}
              >
                <Button
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  padding="0px 0px 0px 0px"
                  shrink="0"
                  size="small"
                  isDisabled={false}
                  variation="link"
                  children="MIR_Image3"
                  {...getOverrideProps(overrides, "dvcAttachmentTitle40235101")}
                ></Button>
                <Text
                  fontFamily="Inter"
                  fontSize="12px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="12px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Type: Image"
                  {...getOverrideProps(overrides, "dvcAttachmentType40235102")}
                ></Text>
              </Flex>
              <Flex
                gap="6px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="9px 9px 9px 9px"
                {...getOverrideProps(overrides, "dcViewRow40235103")}
              >
                <Button
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  padding="0px 0px 0px 0px"
                  shrink="0"
                  size="small"
                  isDisabled={false}
                  variation="link"
                  children="MIR_Image4"
                  {...getOverrideProps(overrides, "dvcAttachmentTitle40235104")}
                ></Button>
                <Text
                  fontFamily="Inter"
                  fontSize="12px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="12px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Type: Image"
                  {...getOverrideProps(overrides, "dvcAttachmentType40235105")}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
